import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  create(attrs) {
    const url = apiRoutes.apiV1BuyerLoanOfficersBidRequestsPath();

    return FetchHelpers.post(url, attrs);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/buyer/loanOfficers/BidRequestsRepository.js